import { render } from "./Departments.vue?vue&type=template&id=50fa3bd8&scoped=true"
import script from "./Departments.vue?vue&type=script&lang=ts"
export * from "./Departments.vue?vue&type=script&lang=ts"

import "./Departments.vue?vue&type=style&index=0&id=50fa3bd8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50fa3bd8"

export default script